/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApi } from './base';

const getProduitDomaine = () => `${baseUrlApi}/produit-domaine/360_PACS`;

export default getProduitDomaine;
